import React, { useEffect, useState } from "react";
import { IonProgressBar, IonSpinner, IonText } from "@ionic/react";
import cmeGroupLogo from "../../../img/cme_logo_transparent.png";
import OneErrorBackdrop from "../ErrorBackdrop/OneErrorBackdrop";

type OneOverlayLoaderProps = {
  loadingText: string[];
  shouldDisplayLogoAndSlogan: boolean;
};
const OneOverlayLoader: React.FC<OneOverlayLoaderProps> = ({
  loadingText,
  shouldDisplayLogoAndSlogan,
}) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentText, setCurrentText] = useState(loadingText[currentTextIndex]);
  const [isCMEDDownOrNetworkIssue, setIsCMEDDownOrNetworkIssue] =
    useState(false);

  useEffect(() => {
    let interval: string | number | NodeJS.Timeout | undefined;
    if (
      loadingText[currentTextIndex] === "This is taking longer than usual..."
    ) {
      interval = setInterval(() => {
        setCurrentTextIndex(
          (prevIndex) => (prevIndex + 1) % loadingText.length,
        );
      }, 24000);
    } else if (
      loadingText[currentTextIndex] === "Fetching Internal Admin Permissions..."
    ) {
      interval = setInterval(() => {
        setCurrentTextIndex(
          (prevIndex) => (prevIndex + 1) % loadingText.length,
        );
      }, 5000);
    } else if (
      loadingText[currentTextIndex] === "Fetching FCM Permissions..."
    ) {
      interval = setInterval(() => {
        setCurrentTextIndex(
          (prevIndex) => (prevIndex + 1) % loadingText.length,
        );
      }, 4000);
    } else if (loadingText[currentTextIndex] === "Error connecting to CMED") {
      setIsCMEDDownOrNetworkIssue(true);
    } else {
      interval = setInterval(() => {
        setCurrentTextIndex(
          (prevIndex) => (prevIndex + 1) % loadingText.length,
        );
      }, 3000);
    }

    return () => clearInterval(interval);
  }, [currentText]);

  useEffect(() => {
    setCurrentText(loadingText[currentTextIndex]);
  }, [currentTextIndex, loadingText]);

  return (
    <>
      {isCMEDDownOrNetworkIssue ? (
        <OneErrorBackdrop errorMsg="We couldn’t connect you to CMED. Please logout and login again." />
      ) : (
        <div className="one-loader-overlay">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {shouldDisplayLogoAndSlogan && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 5,
                }}
              >
                <div className="logo-container">
                  <img src={cmeGroupLogo} alt="Logo" className="logo" />
                  <IonText color="primary">
                    <p className="ion-no-margin logo-text">CME Direct</p>
                  </IonText>
                  <div className="progess-bar">
                    <IonProgressBar
                      type="indeterminate"
                      style={{ width: "80px" }}
                    ></IonProgressBar>
                  </div>
                  <IonText
                    color={
                      currentText === "Error connecting to CMED"
                        ? "danger"
                        : "medium"
                    }
                  >
                    <p className="ion-no-margin loading-text">{currentText}</p>
                  </IonText>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OneOverlayLoader;
